// extracted by mini-css-extract-plugin
module.exports = {"container":"PlayerDetail_container__IdxPF"};